{{#if showSubGrid}}
<thead>
<tr>
	{{#each this.columns}}
		<th>{{this.label}}</th>
	{{/each}}
</tr>
</thead>
<tbody></tbody>
{{/if}}
